module.exports = __webpack_public_path__ + "img/tallers_bici.46c41bf1.svg";